import { render } from "./UiInputRadio.vue?vue&type=template&id=5f395dd5"
import script from "./UiInputRadio.vue?vue&type=script&lang=js"
export * from "./UiInputRadio.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__